import { RunnerProvider } from "gitpod-next-api/gitpod/v1/runner_configuration_pb"
import { type FC, useMemo } from "react";

export const RunnerProviderLabel: FC<{ provider: RunnerProvider }> = ({ provider }) => {
    const label = useMemo(() => toRunnerType(provider), [provider]);
    return <div className="flex grow text-sm text-content-primary">{label}</div>;
};

const toRunnerType = (provider: RunnerProvider): string => {
    switch (provider) {
        case RunnerProvider.DESKTOP_MAC:
            return "Your computer";
        case RunnerProvider.AWS_EC2:
            return "Amazon EC2";
        case RunnerProvider.LINUX_HOST:
            return "Linux";
        default:
            return "Unknown";
    }
};
